import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import CalcService from "src/services/calc-service"
import ParameterTable from "src/components/table/parameter-table"
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_TIME_FORMAT_SHOW, DATE_FORMAT_SHOW } from "src/utils/constants"
import { formatDateUtc } from "src/utils/date-format"
import { formatDecimalCaseReplaceComma } from "src/utils/format-decimal"

const ParameterCalcSpreadsDevedorOverlayTable = (props) => {
    const calcService = new CalcService()
    const [data, setData] = useState([])

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        calcService.loadEndpoint(props.endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))

            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
                'CETIP': "N/A",
                'DataReferencia': dayjs().format(DATE_FORMAT),
                'DU': 0,
                'SpreadsOverlay': 0,
                'Analista': 0,
        }

        props.loading(true)
        return calcService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, CETIP, SpreadsOverlay, Analista, DU, DataReferencia } = newRow

        const body = {
            'CETIP': CETIP,
            'SpreadsOverlay': SpreadsOverlay,
            'Analista': Analista,
            'DU': DU,
            'DataReferencia': DataReferencia,
        }

        props.loading(true)
        return calcService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        const { ID } = row
        return calcService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            flex: true,
            minWidth: 70,
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            flex: 1,
            minWidth: 120,
            editable: true
        },
        {
            field: 'DataReferencia',
            headerName: 'Data Referência',
            flex: true,
            editable: true,
            type: 'date',
            minWidth: 130,
            renderCell: (params) => formatDateUtc(params.value, DATE_FORMAT_SHOW),
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => dayjs(params.value).format(DATE_FORMAT),
            valueParser: (newValue) => dayjs(newValue).format(DATE_FORMAT)
        },
        {
            field: 'DU',
            headerName: 'DU',
            type: 'number',
            flex: 1,
            minWidth: 130,
            renderCell: (params) => formatDecimalCaseReplaceComma(params.value),
            editable: true
        },
        {
            field: 'SpreadsOverlay',
            headerName: 'Spreads Overlay',
            flex: 1,
            minWidth: 130,
            renderCell: (params) => formatDecimalCaseReplaceComma(params.value),
            editable: true
        },
        {
            field: 'Analista',
            headerName: 'Analista',
            type: 'number',
            flex: 1,
            minWidth: 70,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        }
    ]

    return (
        <div>
            <ParameterTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                loadData={loadData} />
        </div>
    )
}

ParameterCalcSpreadsDevedorOverlayTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterCalcSpreadsDevedorOverlayTable
